import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  query getKey($domain: String!, $key: String!) {
    getKey(domain: $domain, key: $key) {
      data,
      readers,
      writers,
    }
  }
`);
